import React from "react";
import { colors } from "../../../data/colors";
import { rowColor } from "../../../utils/rowColor";
import { stdObject } from "../../../data/types/stdObject";
import { getAlignText } from "../../../utils/getAlignText";

export const BoxRow = React.memo(
  ({
    e,
    type,
    index,
    statusDict,
    mainHeader,
    openRowInfo,
    writeInfo,
  }: stdObject) => {
    return (
      <tr
        onDoubleClick={() => openRowInfo(e)}
        className="listTableRow"
        key={e[`COD${type}`]}
        style={{
          backgroundColor: rowColor({
            data: e,
            index,
            statusCode: `EST3${type}`,
            serviceColor: "PAGSEV" in e ? statusDict[e.PAGSEV]?.COLPAG : null,
          }),
        }}
      >
        {mainHeader.map((v: any, idx: number) => (
          <td
            key={idx}
            style={{
              borderBottom: "solid 1px " + colors.lightGrey,
              color: e[`EST3${type}`] === 2 ? colors.grey : colors.black,
            }}
            align={getAlignText(v.ALICAB)}
          >
            {writeInfo(v.CODCAB, e)}
          </td>
        ))}
      </tr>
    );
  },
);
